module.exports = __webpack_public_path__ + "static/media/statueOfLibertyFoggy.19766cc6.jpg";